import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Element from 'element-ui'
import '@/style/style.css'
import '@/assets/iconfont/iconfont.css'
import 'element-ui/lib/theme-chalk/index.css'
import '../theme/index.css'
import common from '@/assets/js/common.js'
import VueLazyload from 'vue-lazyload'
import api from  "@/api/api"
import noImg from '@/assets/img/common/noimg.png'
import VueCropper from 'vue-cropper' 
import VueDND from 'awe-dnd'


Vue.prototype.common = common;//公共方法js
Vue.prototype.api = api;//请求api
Vue.prototype.$bus = new Vue() // event Bus 用于无关系组件间的通信。
Vue.prototype.process = {
  env: process.env
};

Vue.use(Element, { size: 'small' }) //Element
Vue.use(VueCropper)//图片裁剪插件
Vue.use(VueLazyload,{ //懒加载
  error:noImg,
  loading:''
});
Vue.use(VueDND)//拖动插件

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

/**
 * 监听isRouterAlive，
 * 当被设为false时，
 * 将它设为true，避免异步问题
 */
store.watch(
    // 当返回结果改变...
    (state) => {
      return state.isRouterAlive
    },
    // 执行回调函数
    (newVal,oldValue) => {
      if(!newVal){
        store.dispatch('setIsRouterAlive', true)
      }
    }
)
document.oncontextmenu = function() {
  return false;
}
//判断设备是否为手机
!function () {
  var devices = ["iPhone","Android","Windows Phone"]
  var ua = window.navigator.userAgent
  let isTrue = false;//true 移动端
  for (var i = 0; i < devices.length; i++) {
      if (ua.indexOf(devices[i]) !== -1) {
        isTrue = true;
      }
  }
  if(process.env.VUE_APP_MODE==='production' && isTrue){
    window.location.href = 'http://m.zaizhan.cn/#/'
  }else if(process.env.VUE_APP_MODE==='test' && isTrue){
    window.location.href = 'http://120.78.79.8:8080/qiantai/h5-project/zaizhan/dist/#/'
  }
}();
// 谷歌 版本 89.0.4389.90 对_blank的跳转行为做了限制，主动添加了 rel =“ noopener”属性，原属性 rel="opener"
(function() {
  let token = sessionStorage.getItem("token");
  if (!token) {
    // 这个调用能触发目标事件，从而达到共享数据的目的
    localStorage.setItem("getSessionStorage", Date.now());
  }
  // 该事件是核心
  window.addEventListener("storage", function(event) {
    if (event.key == "getSessionStorage") {
      // 已存在的标签页会收到这个事件
      localStorage.setItem("sessionStorage", JSON.stringify(sessionStorage));
      localStorage.removeItem("sessionStorage");
    } else if (event.key == "sessionStorage" && !sessionStorage.length) {
      // 新开启的标签页会收到这个事件
      var data = JSON.parse(event.newValue);
      for (let key  in data) {
        sessionStorage.setItem(key, data[key]);
      }
    }
  });
})();
